import { Calendar as AntdCalendar } from 'antd';

export const Calendar = AntdCalendar;
export default Calendar;
